import { useContext } from "react"
import { AuthContext } from "../context/AuthProvider";

const useAuth = () => {
    const auth = useContext(AuthContext);

    // return context value
    return auth;
}

export default useAuth;